import { createSelector, createSlice } from '@reduxjs/toolkit';

const timeTrackerSlice = createSlice({
    name: 'timeTracker',
    initialState: {
        shifts: [],
        total: 0,
        counts: {
            notStarted: 0,
            inProgress: 0,
            paused: 0,
            ended: 0,
            shifts: 0,
        },
        // Seconds the server clock is ahead of the browser, so live timers
        // stay right even when the admin's machine clock drifts.
        serverOffset: 0,
        window: { from: '', to: '' },
        isLoading: false,
        // Contractor rows (`jobId:userId`) with an action in flight.
        pendingActions: {},
    },
    reducers: {
        fetchTimeTracker: (state, { payload }) => {
            // Silent refreshes (after an action) keep the list on screen.
            if (!payload?.silent) state.shifts = [];
            state.isLoading = true;
        },
        timeTrackerFetched: (state, { payload }) => {
            state.shifts = payload.results || [];
            state.total = payload.total || 0;
            state.counts = payload.counts || state.counts;
            state.window = payload.window || state.window;
            state.serverOffset = payload.serverNow
                ? payload.serverNow - Math.floor(Date.now() / 1000)
                : 0;
            state.isLoading = false;
        },
        timeTrackerFetchFailed: state => {
            state.isLoading = false;
        },
        runTrackerAction: (state, { payload }) => {
            state.pendingActions[`${payload.jobId}:${payload.userId}`] = true;
        },
        trackerActionFinished: (state, { payload }) => {
            delete state.pendingActions[`${payload.jobId}:${payload.userId}`];
        },
    },
});

const getSelf = state => state.timeTracker;
export const getTimeTrackerShifts = createSelector(getSelf, s => s.shifts);
export const getTimeTrackerTotal = createSelector(getSelf, s => s.total);
export const getTimeTrackerCounts = createSelector(getSelf, s => s.counts);
export const getTimeTrackerLoading = createSelector(getSelf, s => s.isLoading);
export const getTimeTrackerWindow = createSelector(getSelf, s => s.window);
export const getTimeTrackerServerOffset = createSelector(
    getSelf,
    s => s.serverOffset,
);
export const getTrackerPendingActions = createSelector(
    getSelf,
    s => s.pendingActions,
);

export const {
    fetchTimeTracker,
    timeTrackerFetched,
    timeTrackerFetchFailed,
    runTrackerAction,
    trackerActionFinished,
} = timeTrackerSlice.actions;

export default timeTrackerSlice.reducer;
